import d3 = require('d3');
import L = require('leaflet');
L.Proj = require('proj4leaflet');

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IGraphModel } from './models/graphmodel';

import proj4leaflet = require('proj4leaflet');

export class Utils {
  public static centerOfWorld = new L.LatLng(53.219231, 6.57537); // pronkjewail

  // oude gemeente Groningen
  public static stadBounds = L.latLngBounds(
    L.latLng(53.270095463639024, 6.674895670499025),
    L.latLng(53.17565783465344, 6.452106467983061)
  );

  // Gemeente inclusief Ten Boer en Haren
  public static gemeenteBounds = L.latLngBounds(
    L.latLng(53.31296374313122, 6.7725268661368005),
    L.latLng(53.106198741185324, 6.46274562898164)
  );

  public static getRDProjection() {
    // coördinatensysteem van de Rijksdriehoeksmeting
    // deze zijn nodig voor bijvoorbeeld de PDOK (kadaster) kaarten

    return new L.Proj.CRS(
      'EPSG:28992',
      `+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 \
       +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m \
       +towgs84=565.2369,50.0087,465.658,-0.406857330322398,0.350732676542563,
       -1.8703473836068,4.0812 +no_defs`,
      {
        resolutions: [
          3440.64,
          1720.32,
          860.16,
          430.08,
          215.04,
          107.52,
          53.76,
          26.88,
          13.44,
          6.72,
          3.36,
          1.68,
          0.84,
          0.42,
          0.21,
        ],
        bounds: L.bounds([-285401.92, 22598.08], [595401.9199999999, 903401.9199999999]),
        origin: [-285401.92, 22598.08],
      }
    );
  }

  public static QUARTERS = {
    '991': 1,
    '992': 2,
    '993': 3,
    '994': 4,
  };

  public static redGreenColors = [
    // "#EEEEEE",
    '#d73027',
    '#fc8d59',
    '#fee08b',
    '#ffffbf',
    '#d9ef8b',
    '#91cf60',
    '#1a9850',
  ];
  public static bluesColors = [
    // "#EEEEEE",
    // marcel's colors
    // "#e6eeff",
    // "#b3ccff",
    // "#80aaff",
    // "#3377ff",
    // "#0055ff",
    // "#0044cc",
    // "#003399",
    // wild sea's colors
    '#EFF3FF',
    '#C5DBEF',
    '#9EC9E0',
    '#6BAED6',
    '#4292C5',
    '#3471B5',
    '#244594',
  ];

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  // http://www.w3.org/WAI/ER/WD-AERT/#color-contrast
  public static brightness(rgb) {
    return rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114;
  }

  public static responsivefy(svg, maxWidth = 650) {
    if (!svg.node()) {
      return;
    }

    // get container + svg aspect ratio
    const container = d3.select(svg.node().parentNode);
    const width = parseInt(svg.style('width'), 10);
    const height = parseInt(svg.style('height'), 10);
    const aspect = width / height;

    // add viewBox and preserveAspectRatio properties,
    // and call resize so that svg resizes on inital page load
    svg
      .attr('viewBox', '0 0 ' + width + ' ' + height)
      .attr('perserveAspectRatio', 'xMidYMid')
      .call(resize);

    // to register multiple listeners for same event type,
    // you need to add namespace, i.e., 'click.foo'
    // necessary if you call invoke this function for multiple svgs
    // api docs: https://github.com/mbostock/d3/wiki/Selections#on
    d3.select(window).on('resize.' + container.attr('id'), () => {
      window.setTimeout(() => {
        // DIKKE HACK: gebruikt in wheel de in eerste instantie op
        // hidden staat zodat we geen flash van een enorm groot wheel
        // krijgen.. zou mooier kunnen maar voor nu staat het hier
        svg.style('visibility', null);
        // einde hack
        resize();
      }, 0);
    });

    // get width of container and resize svg to fit it
    function resize() {
      const targetWidth = Math.min(maxWidth, parseInt(container.style('width'), 10));
      if (!isNaN(targetWidth)) {
        svg.attr('width', targetWidth);
        svg.attr('height', Math.round(targetWidth / aspect));

        // TODO: kan denk ik weg:
        svg.attr('viewBox', '0 0 ' + width + ' ' + height).attr('perserveAspectRatio', 'xMidYMid');

        // sort of a hack to scale the text inside the SVG
        // let scale = width / svg.node().getBoundingClientRect().width;
        // svg.attr('font-size', `${scale}rem`);
      }
    }
  }

  public static guid() {
    const s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    // return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    //  s4() + '-' + s4() + s4() + s4();
    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
  }

  public static getKompasLegend() {
    // <= 67,2: zeer ongunstig (donkerste rood);
    // > 67,2 en <= 86,6; ongunstig (rood);
    // > 86,6 en <= 95; beperkt ongunstig (licht rood);
    // > 95 en < 105; neutraal (geel);
    // => 105 en < 113,4; beperkt gunstig (licht groen);
    // => 113,4 en < 132,8; gunstig (groen);
    // => 132,8; zeer gunstig (donker groen).
    return {
      stoplicht: [
        { min: 0, max: 67.2, level: 1, label: 'zeer ongunstig' },
        { min: 67.2, max: 86.6, level: 2, label: 'ongunstig' },
        { min: 86.6, max: 95, level: 3, label: 'beperkt ongunstig' },
        { min: 95.0, max: 105, level: 4, label: 'neutraal' },
        { min: 105, max: 113.4, level: 5, label: 'beperkt gunstig' },
        { min: 113.4, max: 132.8, level: 6, label: 'gunstig' },
        { min: 132.8, max: 200, level: 7, label: 'zeer gunstig' },
      ],
      blauw: [
        { min: 0, max: 67.2, level: 1, label: 'beduidend lager' },
        { min: 67.2, max: 86.6, level: 2, label: 'lager' },
        { min: 86.6, max: 95, level: 3, label: 'beperkt lager' },
        { min: 95.0, max: 105, level: 4, label: 'neutraal' },
        { min: 105, max: 113.4, level: 5, label: 'beperkt hoger' },
        { min: 113.4, max: 132.8, level: 6, label: 'hoger' },
        { min: 132.8, max: 200, level: 7, label: 'beduidend hoger' },
      ],
    };
  }

  private static instance: Utils; // singleton pattern

  public inMemoryData$: Observable<{}>;

  public mediaURL: string = null;
  public rootIndicator: number = null;

  protected inMemoryData: BehaviorSubject<{}> = new BehaviorSubject({});

  protected meetwaardenCache = {};
  protected indicatorCache = {};

  private indicatorenPromise;
  private wijkenPromise;
  private stadsdelenPromise;
  private kompassenDataPromise;
  private wijkIndicatorMeetwaardePromise = {};
  private wijkIndicatorTekstDataPromise: Promise<{}> = null;
  private cachedPromises = {};

  private constructor() {
    this.inMemoryData$ = this.inMemoryData.asObservable();
    const body = document.getElementsByTagName('BODY')[0];
    this.mediaURL = body.getAttribute('data-media-url');
    this.rootIndicator = parseInt(body.getAttribute('data-root-indicator'), 10);
  }

  // The maximum is exclusive and the minimum is inclusive
  public getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  public range(count: number, start = 0) {
    return Array.apply(0, Array(count)).map((element, index) => {
      return index + start;
    });
  }

  public setMemoryData(key: string, value: any, emit = true) {
    if (this.inMemoryData[key] !== value) {
      this.inMemoryData[key] = value;
      if (emit) {
        this.inMemoryData.next(this.inMemoryData);
      }
    }
  }

  public setRandomData() {
    this.setMemoryData('selectedIndicator', String(this.getRandomInt(1, 53)));
  }

  public getJsonPromise(url: string): Promise<{}> {
    if (url in this.cachedPromises) {
      return this.cachedPromises[url];
    }

    const promise = new Promise((resolve, reject) => {
      fetch(url)
        .then(data => {
          resolve(data.json());
        })
        .catch(error => reject(error));
    });

    this.cachedPromises[url] = promise;
    return promise;
  }

  public getWijken() {
    if (!this.wijkenPromise) {
      this.wijkenPromise = this.getJsonPromise('/api/rest/wijken/');
    }
    return this.wijkenPromise;
  }

  public getStadsdelen() {
    if (!this.stadsdelenPromise) {
      this.stadsdelenPromise = this.getJsonPromise('/api/rest/stadsdelen/');
    }
    return this.stadsdelenPromise;
  }

  public getGraphModel(id: number): Promise<IGraphModel> {
    return this.getJsonPromise(`/api/v2/pages/${id}`);
  }

  public getCluster(url: string): Promise<DocumentFragment> {
    return new Promise((resolve, reject) => {
      d3.html(url)
        .then(data => resolve(data))
        .catch(error => reject(error));
    });
  }

  public getKompassenData() {
    if (!this.kompassenDataPromise) {
      this.kompassenDataPromise = this.getJsonPromise('/api/v2/wijkkompassen/?limit=100');
    }
    return this.kompassenDataPromise;
  }

  public getWijkIndicatorTekstData(): Promise<{}> {
    /* FOR NOW: just get all records. We might need to query this only per wijk */
    if (!this.wijkIndicatorTekstDataPromise) {
      this.wijkIndicatorTekstDataPromise = this.getJsonPromise('/api/v2/wijkindicatorteksten/?limit=1000');
    }
    return this.wijkIndicatorTekstDataPromise;
  }

  public getIndicatoren() {
    if (!this.indicatorenPromise) {
      this.indicatorenPromise = this.getJsonPromise('/api/rest/indicatoren/');
    }
    return this.indicatorenPromise;
  }

  public getIndicator(indicatorId: number) {
    if (indicatorId in this.indicatorCache) {
      return this.indicatorCache[indicatorId];
    }
    const promise = this.getJsonPromise(`/api/rest/indicatoren/${indicatorId}/`);
    this.indicatorCache[indicatorId] = promise;
    return this.indicatorCache[indicatorId];
  }

  public getMeetwaarden(params) {
    /*
     * retrieve the meetwaarden from the rest api
     * note the the result is cached based on the params
     * @returns a cached Promise with the meetwaarden array
     */

    const qs = Object.keys(params)
      .map(k => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`;
      })
      .join('&');

    if (qs in this.meetwaardenCache) {
      return this.meetwaardenCache[qs];
    }

    const promise = this.getJsonPromise(`/api/rest/meetwaarden/?${qs}`);
    this.meetwaardenCache[qs] = promise;
    return this.meetwaardenCache[qs];
  }

  public getWijkenMeetwaarden(variant = 1, jaar = 2024) {
    let cacheKey = `wijkIndicatorMeetwaardePromise-${variant}-${jaar}`;

    if (cacheKey in this.wijkIndicatorMeetwaardePromise) {
      return this.wijkIndicatorMeetwaardePromise[cacheKey];
    }

    this.wijkIndicatorMeetwaardePromise[cacheKey] = new Promise((resolve, reject) => {
      let cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        let deserialized = JSON.parse(cached);
        resolve(deserialized);
      }

      this.fetchAndProcessMeetwaardenData(variant, jaar, resolve);
    });

    return this.wijkIndicatorMeetwaardePromise[cacheKey];
  }

  /**
   * Fetches and processes meetwaarden data for a specific year and variant
   * @param {number} variant - The variant (1=Stand, 2=Wijkontwikkeling, 3=Relatieve ontwikkeling)
   * @param {number} jaar - The year to fetch data for
   * @param {Function} resolve - Promise resolve function
   */
  private fetchAndProcessMeetwaardenData(variant: number, jaar: number, resolve: Function) {
    const cacheKey = `wijkIndicatorMeetwaardePromise-${variant}-${jaar}`;
    const dataPromises = this.createDataFetchPromises(variant, jaar);

    Promise.all(dataPromises).then(([wijkenArray, meetwaarden, meetwaardenComparison, indicatorArray]) => {
      const wijkenMeetwaardeLookup = this.processMeetwaardenData(
        wijkenArray,
        meetwaarden,
        meetwaardenComparison,
        indicatorArray
      );

      this.cacheAndResolveMeetwaardenData(cacheKey, wijkenMeetwaardeLookup, resolve);
    });
  }

  /**
   * Creates the promises needed to fetch all required data
   * @param {number} variant - The variant
   * @param {number} jaar - The year to fetch data for
   * @returns {Array} Array of promises [wijken, meetwaarden, meetwaardenComparison, indicatoren]
   */
  private createDataFetchPromises(variant: number, jaar: number) {
    const wijkenPromise = this.getWijken();

    // Current data: fetch data for the specified year
    const meetwaardenPromise = this.getMeetwaarden({
      variant,
      indicator: Utils.Instance.rootIndicator,
      jaar: jaar,
    });

    // Comparison data: fetch data for the comparison year
    const meetwaardenComparisonPromise = this.createComparisonDataPromise(variant, jaar);

    const indicatorenPromise = this.getIndicatoren();

    return [wijkenPromise, meetwaardenPromise, meetwaardenComparisonPromise, indicatorenPromise];
  }

  /**
   * Creates the comparison data promise based on the current year
   * @param {number} variant - The variant
   * @param {number} jaar - The current year
   * @returns {Promise} Promise for comparison data
   */
  private createComparisonDataPromise(variant: number, jaar: number) {
    if (!jaar) {
      return Promise.resolve([]);
    }

    // Determine comparison year:
    // - If current year is 2022, compare with 2020
    // - Otherwise, compare with 2022
    const comparisonYear = jaar === 2022 ? 2020 : 2022;

    return this.getMeetwaarden({
      variant,
      indicator: Utils.Instance.rootIndicator,
      jaar: comparisonYear,
    });
  }

  /**
   * Processes the raw meetwaarden data into the final lookup structure
   * @param {Array} wijkenArray - Array of wijk objects
   * @param {Array} meetwaarden - Current year meetwaarden data
   * @param {Array} meetwaardenComparison - Comparison year meetwaarden data
   * @param {Array} indicatorArray - Array of indicator objects
   * @returns {Object} Processed wijkenMeetwaardeLookup object
   */
  private processMeetwaardenData(
    wijkenArray: any[],
    meetwaarden: any[],
    meetwaardenComparison: any[],
    indicatorArray: any[]
  ) {
    // Process current year data into lookup table
    const currentYearLookup = this.createMeetwaardenLookup(meetwaarden, 'current');

    // Process comparison year data into lookup table
    const comparisonYearLookup = this.createMeetwaardenLookup(meetwaardenComparison, 'comparison');

    // Create indicator hierarchy
    const indicatorenTree = d3
      .stratify()
      .id(d => (d as any).id)
      .parentId(d => (d as any).parent_id)(indicatorArray);

    // Build final lookup structure
    return this.buildFinalLookupStructure(wijkenArray, indicatorenTree, currentYearLookup, comparisonYearLookup);
  }

  /**
   * Creates a lookup table from raw meetwaarden data
   * @param {Array} meetwaarden - Raw meetwaarden data
   * @param {string} type - Type of data ('current' or 'comparison')
   * @returns {Object} Lookup table
   */
  private createMeetwaardenLookup(meetwaarden: any[], type: 'current' | 'comparison') {
    const lookup = {};

    for (const meting of meetwaarden) {
      if (!lookup.hasOwnProperty(meting.wijk)) {
        lookup[meting.wijk] = {};
      }

      if (type === 'current') {
        // Current data: [waarde, categorie, schermwaarde]
        lookup[meting.wijk][meting.indicator] = [meting.waarde, meting.categorie, meting.schermwaarde];
      } else {
        // Comparison data: [categorie]
        lookup[meting.wijk][meting.indicator] = [meting.categorie];
      }
    }

    return lookup;
  }

  /**
   * Builds the final lookup structure by combining current and comparison data
   * @param {Array} wijkenArray - Array of wijk objects
   * @param {Object} indicatorenTree - D3 hierarchy of indicators
   * @param {Object} currentYearLookup - Current year data lookup
   * @param {Object} comparisonYearLookup - Comparison year data lookup
   * @returns {Object} Final wijkenMeetwaardeLookup
   */
  private buildFinalLookupStructure(
    wijkenArray: any[],
    indicatorenTree: any,
    currentYearLookup: any,
    comparisonYearLookup: any
  ) {
    const wijkenMeetwaardeLookup = {};

    for (const wijk of wijkenArray) {
      wijkenMeetwaardeLookup[wijk.id] = {};

      for (const node of indicatorenTree.descendants()) {
        // Get current year data for this wijk and indicator
        const currentData = this.getWijkIndicatorMeetwaarde(currentYearLookup, wijk.id, node);

        // Get comparison year data for this wijk and indicator
        const comparisonData = this.getWijkIndicatorMeetwaarde(comparisonYearLookup, wijk.id, node);

        // Get city-wide averages from wijk 0 (customer-set data)
        const wijk0CurrentData = this.getWijkIndicatorMeetwaarde(currentYearLookup, 0, node);
        const wijk0ComparisonData = this.getWijkIndicatorMeetwaarde(comparisonYearLookup, 0, node);

        // Use wijk 0 data if available, otherwise fallback to 0
        const averageCurrentData = wijk0CurrentData && wijk0CurrentData.length > 1 ? wijk0CurrentData[1] : 0;
        const averageComparisonData =
          wijk0ComparisonData && wijk0ComparisonData.length > 1 ? wijk0ComparisonData[1] : 0;

        // Combine all data into final array: [waarde, categorie, schermwaarde, vergelijk_categorie, gemiddelde_categorie, gemiddelde_vergelijking_categorie]
        wijkenMeetwaardeLookup[wijk.id][node.id] = currentData
          .concat(comparisonData)
          .concat(averageCurrentData)
          .concat(averageComparisonData);
      }
    }

    return wijkenMeetwaardeLookup;
  }

  /**
   * Caches the processed data and resolves the promise
   * @param {string} cacheKey - Cache key
   * @param {Object} wijkenMeetwaardeLookup - Processed data
   * @param {Function} resolve - Promise resolve function
   */
  private cacheAndResolveMeetwaardenData(cacheKey: string, wijkenMeetwaardeLookup: any, resolve: Function) {
    const serialized = JSON.stringify(wijkenMeetwaardeLookup);
    sessionStorage.setItem(cacheKey, serialized);
    resolve(wijkenMeetwaardeLookup);
  }

  /**
   * Constants for the meetwaarden data array structure
   * The final array has 6 elements: [waarde, categorie, schermwaarde, vergelijk_categorie, gemiddelde_categorie, gemiddelde_vergelijking_categorie]
   */
  private static readonly MEETWAARDE_ARRAY_INDICES = {
    WAARDE: 0, // Current year waarde
    CATEGORIE: 1, // Current year categorie
    SCHERMWAARDE: 2, // Current year schermwaarde
    VERGELIJK_CATEGORIE: 3, // Comparison year categorie
    GEMIDDELDE_CATEGORIE: 4, // Current year average categorie
    GEMIDDELDE_VERGELIJK_CATEGORIE: 5, // Comparison year average categorie
  };

  public meetwaardeToZscore = (value: number): number => {
    // 01/9/2018 uit email van Marcel Seubring
    //
    // Zeer ongunstig / zeer laag: <= -32,8;
    // Ongunstig / laag: > -32,8 <= -13,4;
    // Beperkt ongunstig / beperkt laag: > -13,4 <= -5;
    // Neutraal: > -5 < 5;
    // Beperkt gunstig / beperkt hoog: >= 5 < 13,4;
    // Gunstig / hoog: >= 13,4 < 32,8;
    // Zeer gunstig / zeer hoog: >= 32,8.
    //
    // let zScore = null;
    // if (value !== 0) {
    //   if (value <= -32.8) {
    //     zScore = -3;
    //   } else if (-32.8 < value && value <= -13.4) {
    //     zScore = -2;
    //   } else if (-13.4 < value && value <= -5.0) {
    //     zScore = -1;
    //   } else if (-5.0 < value && value < 5.0) {
    //     zScore = 0;
    //   } else if (5.0 <= value && value < 13.4) {
    //     zScore = 1;
    //   } else if (13.4 <= value && value < 32.8) {
    //     zScore = 2;
    //   } else if (32.8 <= value) {
    //     zScore = 3;
    //   }
    // }

    // Huub: 15/09/2018 toch maar weer terug van 0 - 200
    // <= 67,2: zeer ongunstig (donkerste rood);
    // > 67,2 en <= 86,6; ongunstig (rood);
    // > 86,6 en <= 95; beperkt ongunstig (licht rood);
    // > 95 en < 105; neutraal (geel);
    // => 105 en < 113,4; beperkt gunstig (licht groen);
    // => 113,4 en < 132,8; gunstig (groen);
    // => 132,8; zeer gunstig (donker groen).

    let zScore = null;
    if (value !== 0) {
      if (value <= 67.2) {
        zScore = -3;
      } else if (67.2 < value && value <= 86.6) {
        zScore = -2;
      } else if (86.6 < value && value <= 95.0) {
        zScore = -1;
      } else if (95.0 < value && value < 105.0) {
        zScore = 0;
      } else if (105.0 <= value && value < 113.4) {
        zScore = 1;
      } else if (113.4 <= value && value < 132.8) {
        zScore = 2;
      } else if (132.8 <= value) {
        zScore = 3;
      }
    }
    return zScore;
  };

  protected getWijkIndicatorMeetwaarde = (lookupTable, wijkId, node) => {
    let meetwaarde = [0];
    if (node.children) {
      let numRelevantChildren = 0;
      for (const childNode of node.children) {
        const waarde = this.getWijkIndicatorMeetwaarde(lookupTable, wijkId, childNode);
        if (waarde[0] !== 0 && node.data.kleurenschema === childNode.data.kleurenschema) {
          meetwaarde[0] += waarde[0];
          numRelevantChildren += 1;
        }
      }
      if (numRelevantChildren) {
        meetwaarde[0] /= numRelevantChildren;
      }
    } else {
      if (lookupTable[wijkId] && lookupTable[wijkId].hasOwnProperty(node.id)) {
        meetwaarde = lookupTable[wijkId][node.id];
      }
    }
    // if (wijkId == 1 && node.id == 99213101) {
    //   console.log(`meetwaarde=${meetwaarde}`);
    // }
    return meetwaarde;
  };

  /**
   * Checks if an indicator is percentage-based based on its eenheid field
   * @param eenheid - The unit string from the indicator model
   * @returns True if the indicator represents percentage data
   */
  public static isPercentage(eenheid?: string): boolean {
    return eenheid ? eenheid.includes('%') : false;
  }

  /**
   * Checks if an indicator is distance-based based on its eenheid field
   * @param eenheid - The unit string from the indicator model
   * @returns True if the indicator represents distance data
   */
  public static isDistance(eenheid?: string): boolean {
    if (!eenheid) return false;
    // Check for distance units, but exclude area units like m2
    return (
      eenheid.includes('km') ||
      eenheid.includes('meter') ||
      (eenheid.includes('m') && !eenheid.includes('m2') && !eenheid.includes('m²'))
    );
  }
}
